import { FC } from 'react';

import { useAtomValue } from 'jotai';
import { LineChart } from '../../../../components/Charts/LineChart/LineChart';
import { CHART_COMPONENTS } from '../../../../types';
import { IInvestmentDataModel } from '../../../../data-models/investment.data-model';
import { selectedViewDatePFJ } from '../../state/PageStateJ';
import { QuartersBuilder } from '../../services/QuartersBuilder';
import { cumulativeQuarterSeries } from '../../services/cumulativeQuarterSeries';
import { earliestOf, isValidDate, plainDateToZonedDateTime } from '../../../../util/date-utilts';
import { IPortfolioChartProps } from './ChartComponent';

export const AmountOfDealsOverTimeChartRoundTracker: FC<IPortfolioChartProps<IInvestmentDataModel>> = (
  props
) => {
  const date = useAtomValue(selectedViewDatePFJ);
  const data = computeChartData(date, props.filteredMetrics);

  return (
    <LineChart
      data={data}
      id={CHART_COMPONENTS.AMOUNT_OF_DEALS_OVER_TIME_RT}
      showLegend={false}
      title={'Participating Rounds'}
      width={640}
      yAxisLabelFormatter={(value) => value as string}
      isFullScreen={props.isFullScreen}
      onOpenFullScreen={props.onOpenFullScreen}
    />
  );
};

export function computeChartData(date: Date, metrics: IInvestmentDataModel[]) {
  const participatingDates = metrics
    .filter((metric) => !!metric.investmentDate && !!metric.gcAmount && metric.gcAmount > 0)
    // Calendar date, not an instant — `new Date` would read it as UTC midnight and shift a
    // quarter-start date into the previous quarter west of Greenwich.
    .map((metric) => plainDateToZonedDateTime(metric.investmentDate))
    .filter(isValidDate);

  const viewDate = date || new Date();

  return cumulativeQuarterSeries(
    participatingDates.map((d) => ({ date: d, value: 1 })),
    QuartersBuilder.axisQuartersSince(earliestOf(participatingDates), viewDate),
    'Number of Rounds'
  );
}
